__turbopack_context__.v({
  "mob": "sK3XBq_mob",
  "root": "sK3XBq_root",
  "web": "sK3XBq_web",
});
